<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newMode">Create New Risk Profiles</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Risk Profiles</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Risk Profiles</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="form.dept"
                  :label="labels.dept"
                  :error-messages="errors.collect('dept')"
                  data-vv-name="dept"
                  :data-vv-as="labels.dept"
                  v-validate="'required'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList()"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.dept }}</v-subheader>
                <div class="queryValue">{{ form.dept }}</div>
              </v-flex>
              <v-flex xs6 v-if="form.dept !== undefined && form.dept !== null">
                <v-subheader class="queryLabel">{{ labels.deptDesc }}</v-subheader>
                <div class="queryValue">{{ deptDesc }}</div>
              </v-flex>
              <v-flex xs12 v-if="newMode">
                <v-autocomplete
                  :label="labels.profType"
                  :items="profTypeList"
                  v-model="form.profType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="profType"
                  :data-vv-as="labels.profType"
                  :error-messages="errors.collect('profType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.profType }}</v-subheader>
                <div class="queryValue" v-for="item in filterProfTypeList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs12 v-if="newMode">
                <v-text-field
                  v-model="form.bandRefNo"
                  :label="labels.bandRefNo"
                  :error-messages="errors.collect('bandRefNo')"
                  data-vv-name="bandRefNo"
                  :data-vv-as="labels.bandRefNo"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.bandRefNo }}</v-subheader>
                <div class="queryValue">{{ form.bandRefNo }}</div>
              </v-flex>
              <v-flex xs12 v-if="!queryMode">
                <v-text-field
                  v-model="form.uppLim"
                  :label="labels.uppLim"
                  :data-vv-as="labels.uppLim"
                  data-vv-name="uppLim"
                  :error-messages="errors.collect('uppLim')"
                  v-validate="'numeric|max:13'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.uppLim }}</v-subheader>
                <div class="queryValue">{{ formatDisplayNumber(form.uppLim) }}</div>
              </v-flex>
              <v-flex xs12 v-if="!queryMode">
                <v-text-field
                  v-model="form.bandDesc"
                  :label="labels.bandDesc"
                  :error-messages="errors.collect('bandDesc')"
                  data-vv-name="bandDesc"
                  :data-vv-as="labels.bandDesc"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.bandDesc }}</v-subheader>
                <div class="queryValue">{{ form.bandDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-spacer class="mt-3"></v-spacer>
          <v-layout>
            <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
              Cancel
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
      <!-- helplist -->
      <v-dialog v-model="showDeptList" width="1280px">
        <dept-help-list @close="showDeptList = false" @assign-dept="assignDept"></dept-help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { profType } from '@/const/underwriting/riskProf'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import DeptHelpList from '@/components/core/common/dialog/DeptHelpList'

export default {
  data() {
    return {
      disabled: true,
      toogleArray: [false],
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      labels: {
        dept: 'Department',
        deptDesc: 'Dept Desc',
        profType: 'Profile Type',
        bandRefNo: 'Band Ref No.',
        uppLim: 'Upper Limit',
        bandDesc: 'Band Ref Desc',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        dept: null,
        profType: null,
        bandRefNo: null,
        uppLim: 0,
        bandDesc: undefined
      },
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      deptDesc: undefined,
      loading: true,
      showDeptList: false
    }
  },
  computed: {
    menu() {
      return this.$store.state.riskProfParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    profTypeList() {
      let result = []
      Object.keys(profType).forEach(function (key) {
        const status = profType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    filterProfTypeList() {
      return this.profTypeList.filter((list) => {
        return list.value === this.form.profType
      })
    }
  },
  watch: {
    'form.dept': function (value) {
      if (value !== undefined && value !== null) {
        this.getDept()
      }
    }
  },
  methods: {
    async fetchData() {
      const apiURI = this.menu.getRiskProf
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.dept = data.riskProf.dept
            this.form.profType = data.riskProf.profType
            this.form.bandRefNo = parseInt(data.riskProf.bandRefNo)
            this.form.uppLim = data.riskProf.uppLim
            this.form.bandDesc = data.riskProf.bandDesc
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getDept() {
      const apiURI = this.menu.getDept
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            dept: this.form.dept
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.deptDesc = data.dept.deptDesc
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'riskProfiles' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else if (this.newMode) {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createRiskProf
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'riskProfiles' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateRiskProf
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'riskProfiles' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList() {
      this.resetMessages()
      this.showDeptList = true
    },
    assignDept(dept) {
      this.form.dept = dept
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatDisplayNumber(val) {
      return formatDisplayNumber(val)
    }
  },
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.fetchData()
    }
  },
  components: {
    DeptHelpList
  },
  mixins: [MessageMixin]
}
</script>
